// extracted by mini-css-extract-plugin
module.exports = {"root":"TabNav_root__klCZw","tab":"TabNav_tab__2t7du","link":"TabNav_link__2m-k3","selectedLink":"TabNav_selectedLink__LXruC","disabled":"TabNav_disabled__hGY6c"};